<script>
import router from "../../router";
import Multiselect from "vue-multiselect";
import Alert from "@/components/Alert";
export default {
  name: "InventoryCount",
  components: {
    Alert,
    Multiselect
  },
  data() {
    return {
      decimal_separator: ".",
precision: 0,
      currency: "",
      order: {
        id: "",
        inventory_count_status: "",
        items: [],
        history: []
      },
      selected_items: [],
      itemList: [],
      item: {
        item: "",
        quantity: 1
      },
      history: {
        item_variant_combination_id: "",
        item_id: "",
        name: "",
        quantity: ""
      },
      historyList: []
    };
  },
  methods: {
    details(id) {
      this.$api
        .getAPI({
          _action: "/inventory_count/detail/" + id
        })
        .then(res => {
          this.order = res;
          this.historyList = res.history;
          for (var i = 0; i < res.items.length; i++) {
            this.selected_items.push(res.items[i]);
            this.itemList.push(res.items[i]);
          }
        });
    },
    getItemList() {
      this.$api
        .getAPI({ _action: "/item/purchase_order", _body: this.filterObj })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.itemList = res.list;
          }
        })
        .catch(e => {});
    },
    setItemName({ name }) {
      return name;
    },
    onItemSelect(option) {
      if (option) {
        this.item.item = option.id;
        this.item.name = option.name;
      }
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.addHistory();
          return;
        }
      });
    },
    addHistory() {
      for (var i = 0; i < this.selected_items.length; i++) {
        if (this.item.item_variant_combination_id) {
          if (
            this.selected_items[i].item_variant_combination_id ==
            this.item.item_variant_combination_id
          ) {
            if (!this.selected_items[i].counted_stock) {
              this.selected_items[i].counted_stock = 0;
            }
            this.selected_items[i].counted_stock =
              1 * this.selected_items[i].counted_stock + 1 * this.item.quantity;
            if (this.selected_items[i].cost) {
              this.selected_items[i].difference =
                this.selected_items[i].counted_stock -
                this.selected_items[i].expected_stock;
              this.selected_items[i].difference_cost =
                this.selected_items[i].difference * this.selected_items[i].cost;
            }

            if (this.selected_items[i].counted_stock == 0) {
              this.selected_items[i].counted_stock = null;
              this.selected_items[i].difference = 0;
              this.selected_items[i].difference_cost = 0;
            }
            this.$set(this.selected_items, i, this.selected_items[i]);
            break;
          }
        } else {
          if (this.selected_items[i].item_id == this.item.item_id) {
            if (!this.selected_items[i].counted_stock) {
              this.selected_items[i].counted_stock = 0;
            }
            this.selected_items[i].counted_stock =
              1 * this.selected_items[i].counted_stock + 1 * this.item.quantity;
            if (this.selected_items[i].cost) {
              this.selected_items[i].difference =
                this.selected_items[i].counted_stock -
                this.selected_items[i].expected_stock;
              this.selected_items[i].difference_cost =
                this.selected_items[i].difference * this.selected_items[i].cost;
            }

            if (this.selected_items[i].counted_stock == 0) {
              this.selected_items[i].counted_stock = null;
              this.selected_items[i].difference = 0;
              this.selected_items[i].difference_cost = 0;
            }
            this.$set(this.selected_items, i, this.selected_items[i]);
            break;
          }
        }
      }

      this.history = {};
      if (this.item.item_variant_combination_id) {
        this.history.item_variant_combination_id = this.item.item_variant_combination_id;
      } else {
        this.history.item_id = this.item.item_id;
      }
      this.history.name = this.item.name;
      this.history.quantity = this.item.quantity;
      this.historyList.push(this.history);

      this.order.total_difference = 0;
      this.order.total_difference_cost = 0;
      for (var i = 0; i < this.selected_items.length; i++) {
        this.order.total_difference += this.selected_items[i].difference;
        this.order.total_difference_cost += this.selected_items[
          i
        ].difference_cost;
      }
    },
    removeSelectedHistory(index, obj) {
      this.historyList.splice(index, 1);
      for (var i = 0; i < this.selected_items.length; i++) {
        if (obj.item_variant_combination_id) {
          if (
            this.selected_items[i].item_variant_combination_id ==
            obj.item_variant_combination_id
          ) {
            this.selected_items[i].counted_stock =
              this.selected_items[i].counted_stock - 1 * obj.quantity;
            if (this.selected_items[i].cost) {
              this.selected_items[i].difference =
                this.selected_items[i].counted_stock -
                this.selected_items[i].expected_stock;
              this.selected_items[i].difference_cost =
                this.selected_items[i].difference * this.selected_items[i].cost;
            }
            if (this.selected_items[i].counted_stock == 0) {
              this.selected_items[i].counted_stock = null;
              this.selected_items[i].difference = 0;
              this.selected_items[i].difference_cost = 0;
            }
            this.$set(this.selected_items, i, this.selected_items[i]);
            break;
          }
        } else {
          if (this.selected_items[i].item_id == obj.item_id) {
            this.selected_items[i].counted_stock =
              this.selected_items[i].counted_stock - 1 * obj.quantity;
            if (this.selected_items[i].counted_stock == 0) {
              this.selected_items[i].difference = 0;
              this.selected_items[i].difference_cost = 0;
            } else {
              this.selected_items[i].difference =
                this.selected_items[i].counted_stock -
                this.selected_items[i].expected_stock;
              this.selected_items[i].difference_cost =
                this.selected_items[i].difference * this.selected_items[i].cost;
            }
            this.$set(this.selected_items, i, this.selected_items[i]);
            break;
          }
        }
      }
      if (this.selected_items[index].counted_stock == 0) {
        this.selected_items[index].counted_stock = "";
        this.selected_items[index].difference = 0;
        this.selected_items[index].difference_cost = 0;
      }

      this.order.total_difference = 0;
      this.order.total_difference_cost = 0;
      for (var i = 0; i < this.selected_items.length; i++) {
        this.order.total_difference += this.selected_items[i].difference;
        this.order.total_difference_cost += this.selected_items[
          i
        ].difference_cost;
      }
    },
    calculatedifference(index, obj) {
      this.$validator.validateAll("").then(result => {
        if (result) {
          if (obj.counted_stock) {
            this.history = {};
            var abc = 0;
            if (obj.item_variant_combination_id) {
              for (var i = 0; i < this.historyList.length; i++) {
                if (
                  this.historyList[i].item_variant_combination_id &&
                  this.historyList[i].item_variant_combination_id ==
                    obj.item_variant_combination_id
                ) {
                  abc += 1 * this.historyList[i].quantity;
                }
              }
              this.history.item_variant_combination_id =
                obj.item_variant_combination_id;
            } else {
              for (var i = 0; i < this.historyList.length; i++) {
                if (
                  this.historyList[i].item_id &&
                  this.historyList[i].item_id == obj.item_id
                ) {
                  abc += 1 * this.historyList[i].quantity;
                }
              }
              this.history.item_id = obj.item_id;
            }

            if (!abc) {
              abc = obj.counted_stock;
            } else {
              abc = obj.counted_stock - abc;
            }

            if (abc != 0) {
              this.history.name = obj.name;
              this.history.quantity = abc;
              this.historyList.push(this.history);
            }

            this.selected_items[index].difference =
              this.selected_items[index].counted_stock -
              this.selected_items[index].expected_stock;
            this.selected_items[index].difference_cost =
              this.selected_items[index].difference *
              this.selected_items[index].cost;

            this.order.total_difference = 0;
            this.order.total_difference_cost = 0;
            for (var i = 0; i < this.selected_items.length; i++) {
              this.order.total_difference += Math.abs(this.selected_items[i].difference);
              this.order.total_difference_cost += Math.abs(this.selected_items[i].difference_cost);
            }
          }
        }
      });
    },
    validateFilledValues(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          var index = this.$_.findIndex(this.selected_items, this.item.item)
          this.selected_items[index].counted_stock = (parseInt(this.selected_items[index].counted_stock) || 0)
              + parseInt(this.item.quantity)
          this.calculatedifference(index, this.selected_items[index]);
          return;
        }
      });
    },
    validateBeforeSave(status) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.Save(status);
          return;
        }
      });
    },
    Save(status) {
      this.order.inventory_count_status = status;
      this.order.items = this.selected_items;
      this.order.history = this.historyList;
      this.$api
        .postAPI({
          _action: "/inventory_count/count",
          _body: this.order,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          router.push("/inventory-count");
        })
        .catch(e => {
          console.log(e.message);
        });
    }
  },
  mounted() {
    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
    this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;
    if (localStorage.getItem("currency")) {
      this.currency = localStorage.getItem("currency");
    }

    $(".search-box a, .search-box .app-search .srh-btn").on(
      "click",
      function() {
        $(".app-search").toggle(200);
        $(".app-search input").focus();
      }
    );
    // this.getItemList();
    if (this.$route.params.id) {
      this.details(this.$route.params.id);
    }
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-9">
            <div class="card rounded-5 border">
              <div class="card-body form-style px-lg-5 px-4 py-4">
                <div class="row">
                  <div class="col-lg-12">
                    <form data-vv-scope="modifier-form">
                      <div class="row form-style">
                        <div class="col-lg-6 mb-lg-0 mb-3">
                          <label>{{$lang.messages.count_item}}</label>
                          <br />
                          <multiselect
                            v-validate="'required'"
                            v-model="item.item"
                            :options="itemList"
                            :custom-label="setItemName"
                            :placeholder="$lang.messages.items"
                            label="name"
                            track-by="name"
                            @select="onItemSelect"
                            :class="{'input': true, 'is-danger': errors.has('searchItem') }"
                            name="modifier-form.searchItem"
                                                  :select-label="$lang.messages.please_enter_to_select"
                            :deselect-label="$lang.messages.please_enter_to_remove"
                            :selected-label="$lang.messages.selected"
                      >
                        <span slot="noOptions">{{$lang.messages.list_is_empty}}</span>


                          </multiselect>
                          <i v-show="errors.has('modifier-form.searchItem')" class="fa fa-warning"></i>
                          <span
                            v-show="errors.has('modifier-form.searchItem')"
                            class="help is-danger"
                          >{{$lang.messages.please_select_item}}</span>
                        </div>
                        <div class="col-lg-2">
                          <label>{{$lang.messages.quantity}}</label>
                          <br />
                          <input
                            placeholder="0.00"
                            type="text"
                            v-model="item.quantity"
                            :id="'quantity'"
                            :name="'quantity'"
                            :class="{'form-control':true, 'input': true, 'is-danger': errors.has('modifier-form.quantity') }"
                            v-validate="'required|decimal|min_value:1'"
                          />
                          <i v-show="errors.has('modifier-form.quantity')" class="fa fa-warning"></i>
                          <span
                            v-show="errors.has('modifier-form.quantity')"
                            class="help is-danger"
                          >{{$lang.messages.please_enter_valid_quantity}}</span>
                        </div>
                        <div class="col-lg-4 p-2">
                          <label></label><br>
                          <button
                            type="button"
                            class="btn btn-primary"
                            @click="validateFilledValues('modifier-form')"
                          >{{$lang.messages.add_to_counted}}</button>
                          <i v-show="errors.has('modifier-form.quantity')" class="fa fa-warning"></i>
                          <span
                            v-show="errors.has('modifier-form.quantity')"
                            class="help is-danger"
                          ></span>
                        </div>
                      </div>
                    </form>
                    <table class="table table-striped table-style-1 table-responsive">
                      <thead>
                        <tr>
                          <th scope="col">{{$lang.messages.item}}</th>
                          <th scope="col" width="160">{{$lang.messages.expected_stock}}</th>
                          <th scope="col" width="160">{{$lang.messages.counted}}</th>
                          <th scope="col" width="160">{{$lang.messages.difference}}</th>
                          <th scope="col" width="160">{{$lang.messages.cost_difference}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(obj, index) in selected_items" :key="index">
                          <td>
                            {{obj.name}}
                            <br />
                            <span
                              class="font-14 text-grey"
                              v-if="obj.sku"
                            >{{$lang.messages.sku}} {{obj.sku}}</span>
                          </td>
                          <td>{{obj.expected_stock}}</td>
                          <td>
                            <input
                              type="number"
                              class="form-control text-left"
                              v-model=obj.counted_stock
                              :id="'composite_item_quantity_' + index"
                              :name="'composite_item_quantity_' + index"
                              :class="{'form-control':true, 'input': true, 'is-danger': errors.has('composite_item_quantity_' + index) }"
                              v-validate="'required|decimal'"
                              @blur="calculatedifference(index, obj)"
                            />
                            <i
                              v-show="errors.has('composite_item_quantity_'+ index)"
                              class="fa fa-warning"
                            ></i>
                            <span
                              v-show="errors.has('composite_item_quantity_'+ index)"
                              class="help is-danger"
                            >{{$lang.messages.please_enter_valid_quantity}}</span>
                          </td>
                          <td>{{obj.difference ? Math.abs(obj.difference) : "-" }}</td>
                          <td class="text-right">
                          <vue-numeric
                              v-if="obj.difference_cost"
                              v-bind:precision="precision"
                              :separator="decimal_separator"
                              :value="Math.abs(obj.difference_cost)"
                              :currency="currency"
                              :read-only="true"
                            />
                            <span v-else>-</span>
                        </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="f-semi-bold text-right">{{$lang.messages.total}}</td>
                          <td
                            class="f-semi-bold"
                          >{{order.total_difference ? order.total_difference : "-" }}</td>
                          <td
                            class="f-semi-bold text-right"
                          ><vue-numeric
                              v-if="order.total_difference_cost"
                              v-bind:precision="precision"
                              :separator="decimal_separator"
                              :value="order.total_difference_cost"
                              :currency="currency"
                              :read-only="true"
                            />
                            <span v-else>-</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="card bg-white">
              <div class="card-body px-4 pt-4 bg-white">
              <h3 class="font-22 mb-4">{{$lang.messages.history}}</h3>
                <div class="table-responsive">
                  <table class="table table-style-1 table-border border-top-0 my-0">
                    <tbody>
                      <tr v-for="(obj, index) in historyList" :key="index">
                        <td class="p-2">{{obj.quantity}} {{obj.name}}</td>
                        <td class="p-2 text-right">
                          <button
                            type="button"
                            class="btn btn-outline-light"
                            @click="removeSelectedHistory(index, obj)"
                          >
                            <i class="far fa-trash-alt font-20 text-secondary"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9 text-right">
            <button
              type="button"
              class="btn btn-primary mr-3"
              id="save-btn"
              @click="validateBeforeSave()"
            >{{$lang.messages.save_btn_text}}</button>
            <button
              type="button"
              class="btn btn-outline-primary"
              id="complete-btn"
              @click="validateBeforeSave('COMPLETED')"
            >{{$lang.messages.complete}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
